<div class="flex flex-col gap-4 border-b border-border pb-4">
    <div class="flex flex-col gap-1">
        <p class="text-xs font-medium text-secondary">Campaign</p>
        @if (campaignStore.allCampaigns()) {
        <el-select id="smart-brief-campaign" name="selected" [value]="campaignStore.campaignSelectValue()" class="block">
            <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-spacious-btn">
                <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                    @if (service.selectedCampaign()) {
                    <img [src]="service.selectedCampaign()?.campaignPhoto ? imageService.getImageSource(service.selectedCampaign()?.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                        alt=""
                        class="size-5 shrink-0 rounded-full bg-muted outline -outline-offset-1 outline-white/10" />
                    <p class="m-0 block truncate text-sm">{{ service.selectedCampaign()?.campaignName }}</p>
                    } @else {
                    <p class="m-0 block truncate text-sm">Default Group</p>
                    }
                </el-selectedcontent>
            </button>
            <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                <el-option (click)="campaignStore.onAddCampaignClick($event)"
                    class="relative block cursor-default py-2 pr-3 pl-3 text-primary select-none">
                    <p class="m-0 block truncate text-sm">Add campaign</p>
                </el-option>
                @if (!service.selectedCampaign()) {
                <el-option [value]="campaignStore.campaignSelectNoneValue"
                    class="relative block cursor-default py-2 pr-3 pl-3 text-primary select-none">
                    <p class="m-0 block truncate text-sm">Default Group</p>
                </el-option>
                }
                @for (campaign of campaignStore.allCampaigns(); track campaign.id) {
                <el-option [value]="campaign.id" (click)="campaignStore.selectCampaign(campaign)"
                    class="relative block cursor-default py-2 pr-3 pl-3 text-primary select-none">
                    <p class="m-0 block truncate text-sm">{{ campaign.campaignName }}</p>
                </el-option>
                }
            </el-options>
        </el-select>
        } @else {
        <p class="text-sm text-secondary">Loading campaigns</p>
        }
    </div>

    @if (shoutAgency()) {
    <div class="flex flex-col gap-2">
        <p class="text-xs font-medium text-secondary">Pricing model</p>
        <div class="flex flex-wrap gap-2">
            @for (model of agencyModels(); track model.id) {
            <button type="button" [class]="modelClass(model.id)" (click)="chooseModel(model)">{{ model.title }}</button>
            }
            <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary" (click)="creatingModel.set(true)">Create a model</button>
        </div>
    </div>
    } @else if (service.selectedPricingModel(); as model) {
    <div class="flex flex-col gap-1">
        <p class="text-xs font-medium text-secondary">Pricing model</p>
        <p class="text-sm text-primary">{{ model.title }}</p>
    </div>
    }

    @if (pricePerCreatorLabel(); as price) {
    <div class="flex flex-col gap-1">
        <p class="text-xs font-medium text-secondary">Price per creator</p>
        <p class="text-sm font-semibold text-primary">{{ price }}</p>
    </div>
    }
</div>

@if (campaignStore.showCreateCampaignModal()) {
<create-campaign class="h-full w-full" (campaignCreated)="campaignStore.onCampaignCreated($event)"
    (close)="campaignStore.showCreateCampaignModal.set(false)"></create-campaign>
}

@if (creatingModel()) {
<div class="fixed inset-0 z-50 overflow-auto bg-white p-4 dark:bg-zinc-900">
    <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary mb-4" (click)="creatingModel.set(false)">Close</button>
    <step-agency-pricing (modelSelected)="chooseModel($event)" />
</div>
}
